import { createSlice } from '@reduxjs/toolkit';
import { IState } from 'shared/interfaces/state.interface';
import { initialStore } from '../initial-store';

// Slice
const SuppliesSlice = createSlice({
  name: 'supplies',
  initialState: initialStore.supplies,
  reducers: {
    getPharmacySupplies: (state, { payload }) => {
      if (!state.isLoading) {
        state.isLoading = true;
      }
    },
    setPharmacySupplies: (state, { payload }) => {
      state.isLoading = false;
      state.pharmacySupplies = payload.supplies;
    },
    failAction: (state) => {
      state.isLoading = false;
    }
  }
});

export const { getPharmacySupplies, setPharmacySupplies, failAction } =
  SuppliesSlice.actions;

export const { reducer } = SuppliesSlice;

// Selectors
export const getPharmacySuppliesSelector = (state: IState) =>
  state && state.supplies.pharmacySupplies;
